export const sex = [
	{ name: '男', val: 1 },
	{ name: '女', val: 2 },
	{ name: '未知', val: 0 }
]
export const editType = {
	info: {
		type: 'info',
		title: '个人信息',
		method: 'updateUserInfo',
		rules: {}
	},
  login: {
    type: 'login',
		title: '账号',
		method: 'updateUserInfo',
		rules: {
      login_name: [
        {
					required: true,
          // 	pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*?\\.])[0-9a-zA-Z!@#$%^&*?\\.].+$/,
          // 	message: '密码应包含字母、数字、特殊符号，且限制长度在3到15位',
          trigger: ['blur', 'change'],
          validator: (rule, value, callback) => {
            const lengthValid = value.length >= 3 && value.length <= 15
            const formatValid = value.match(/^[0-9a-zA-Z_.-]+$|^([0-9]+|[a-zA-Z]+)$/)
            if (!lengthValid) {
              callback(new Error('长度必须为 3 - 15 位'))
            } else if (!formatValid) {
              callback(
                new Error(
                  '支持纯数字（如 12345）、纯字母（如 abcde）、下划线"_"、点"."、横"-"或三者任意组合构成，不得出现其他字符'
                )
              )
            } else {
              callback()
            }
          }
        },
      ]
    }
  },
	phone: {
		type: 'phone',
		title: '手机号码',
		method: 'changeAllPhone',
		rules: {
			phone: [
				{ required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
				{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: ['blur', 'change'] }
			],
			code: [
				{ required: true, message: '请输入验证码', trigger: ['blur', 'change'] },
				{ pattern: /^\d{6}$/, message: '验证码格式不正确', trigger: ['blur', 'change'] }
			]
		}
	},
	pass: {
		type: 'pass',
		title: '修改密码',
		method: 'updateUserPass',
		rules: {
			pass_old: [{ required: true, message: '请输入原密码', trigger: ['blur', 'change'] }],
			pass1: [
				// { required: true, min: 6, max: 16, message: '请输入新密码', trigger: ['blur', 'change'] },
				{
					required: true,
					pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*?\\.])[0-9a-zA-Z!@#$%^&*?\\.]{8,}$/,
					message: '密码应包含字母、数字、特殊符号，且限制长度在8到16位',
					trigger: ['blur', 'change']
				}
			],
			pass2: [
				// { required: true, min: 6, max: 16, message: '请输入新密码', trigger: ['blur', 'change'] },
				{
					pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*?\\.])[0-9a-zA-Z!@#$%^&*?\\.]{8,}$/,
					message: '密码应包含字母、数字、特殊符号，且限制长度在8到16位',
					trigger: ['blur', 'change']
				}
			]
		}
	}
}
